import SpeedDatingSmallCard from './container';

export default SpeedDatingSmallCard;



// WEBPACK FOOTER //
// ./src/components/Cards/SpeedDatingSmallCard/index.js